import createForm from "@/utils/form"

export const LoginOtpForm = createForm<{
    countryCode: string
    number: string
    agreeTerms: boolean
}>()

export const LoginOtpCodeForm = createForm<{
    otpId: string
    code: string
}>()

export const LoginPasswordForm = createForm<{
    countryCode: string
    number: string
    password: string
    agreeTerms: boolean
}>()
